var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-menu",class:_vm.theme},[_c('button',{staticClass:"nav-menu-item",attrs:{"type":"button"},on:{"click":_vm.openFDS}},[_vm._v(" 基本面数据 ")]),_c('button',{staticClass:"nav-menu-item",attrs:{"type":"button"},on:{"click":_vm.openBusinessSchool}},[_vm._v(" 商学院 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }